// src/util/generateBreadcrumbTrail.ts
import { StoryblokLink } from '../useStoryblokLinks';

interface BreadcrumbItem {
  name: string;
  url: string;
}

const createBreadcrumbItem = (name: string, url: string): BreadcrumbItem => ({
  name,
  url,
});

const findLinkBySlug = (
  links: StoryblokLink[],
  slug: string
): StoryblokLink | undefined => links.find((entry) => entry.slug === slug);

const findLinkById = (
  links: StoryblokLink[],
  id: string | null
): StoryblokLink | undefined => links.find((entry) => entry.id === id);

const isDuplicateUrl = (trail: BreadcrumbItem[], url: string): boolean =>
  trail.some((item) => item.url === url);

const addParentPage = (
  trail: BreadcrumbItem[],
  parentPage: StoryblokLink | undefined
): void => {
  if (parentPage) {
    trail.push(createBreadcrumbItem(parentPage.name, `/${parentPage.slug}`));
  }
};

export function generateBreadcrumbTrail(
  currentSlug: string,
  links: StoryblokLink[]
): BreadcrumbItem[] {
  const trail: BreadcrumbItem[] = [createBreadcrumbItem('Home', '/')];

  // Add parent page for case studies
  if (currentSlug.startsWith('work/')) {
    const workPage = findLinkBySlug(links, 'work');
    addParentPage(trail, workPage);
  }

  let current = findLinkBySlug(links, currentSlug);
  const pathParts: string[] = [];

  while (current) {
    pathParts.unshift(current.slug);
    const currentUrl = '/' + pathParts.join('/');

    if (!isDuplicateUrl(trail, currentUrl)) {
      trail.push(createBreadcrumbItem(current.name, currentUrl));
    }

    current = findLinkById(links, current.parent_id);
  }

  return trail;
}
